import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=70cfe351&scoped=true&"
import script from "./BlockTitle.vue?vue&type=script&lang=js&"
export * from "./BlockTitle.vue?vue&type=script&lang=js&"
import style0 from "./BlockTitle.vue?vue&type=style&index=0&id=70cfe351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfe351",
  null
  
)

export default component.exports